import { createSlice } from '@reduxjs/toolkit';

import { currentStageColumns } from '@features/crm/utils/helpers';

export const buildBrandListQueryKey = (filterData, activeTab) => {
	const parts = {
		activeTab,
		brand: filterData?.brand?.[0]?.key,
		brandType: filterData?.brandType?.[0]?.key,
		name: filterData?.name?.[0]?.key,
		sort: filterData?.sort?.[0]?.key ?? 'statusUpdatedAt,desc'
	};
	return JSON.stringify(parts);
};

const initialState = {
	activeTab: currentStageColumns[0].value,
	currentPage: 0,
	listScrollY: 0,
	listQueryKey: null,
	listResponse: null
};

const brandListSlice = createSlice({
	name: 'brandList',
	initialState,
	reducers: {
		setBrandListActiveTab: (state, action) => {
			const next = action.payload;
			if (state.activeTab === next) return;
			state.activeTab = next;
			state.listScrollY = 0;
			state.listQueryKey = null;
			state.listResponse = null;
			state.currentPage = 0;
		},
		setBrandListScrollY: (state, action) => {
			const y = action.payload;
			state.listScrollY = typeof y === 'number' && !Number.isNaN(y) ? Math.max(0, y) : 0;
		},
		mergeBrandListPage: (state, action) => {
			const { queryKey, page, response } = action.payload;
			const apiData = response;
			if (!apiData) return;

			state.listQueryKey = queryKey;
			state.currentPage = page;

			if (page === 0) {
				state.listResponse = {
					...apiData,
					data: [...(apiData.data || [])]
				};
			} else {
				const prevData = state.listResponse?.data || [];
				state.listResponse = {
					...apiData,
					data: [...prevData, ...(apiData.data || [])]
				};
			}
		},
		removeBrandFromCrmList: (state, action) => {
			const rawId = action.payload;
			if (rawId === undefined || rawId === null || !state.listResponse?.data) return;
			const idStr = String(rawId);
			const nextData = state.listResponse.data.filter((b) => String(b.id) !== idStr);
			if (nextData.length === state.listResponse.data.length) return;
			state.listResponse = {
				...state.listResponse,
				data: nextData,
				totalElements: Math.max(0, (state.listResponse.totalElements || 0) - 1)
			};
		}
	}
});

export const { setBrandListActiveTab, setBrandListScrollY, mergeBrandListPage, removeBrandFromCrmList } =
	brandListSlice.actions;

export default brandListSlice.reducer;
